export default __webpack_public_path__ + "static/media/aboutme.c01ca3cc.svg";